import { default as moment } from "moment";

export default class DateTimeUtil {

	public static SECOND = 1000;
	public static MINUTE = 1000 * 60;
	public static HOUR = 1000 * 60 * 60;
	public static DAY = 1000 * 60 * 60 * 24;

	public static guessUserTimezone(): string {
		return moment.tz.guess();
	}

	public static isSameDay(d1: moment.MomentInput, d2: moment.MomentInput): boolean {
		return moment(d1).isSame(moment(d2), 'D');
	}

	public static formatDate(date: moment.MomentInput, locale: string, format: string = "L", defaultValue: string = ''): string {
		if (!date) {
			return defaultValue;
		}

		const m = moment(date);

		if (!m.isValid()) {
			return defaultValue;
		}

		m.locale(locale);

		return m.format(format);
	}

	public static fromNow(date: moment.MomentInput, locale: string, defaultValue: string = ''): string {
		if (!date) {
			return defaultValue;
		}

		const m = moment(date);

		if (!m.isValid()) {
			return defaultValue;
		}

		m.locale(locale);

		return m.fromNow();
	}

	public static formatDuration(duration: number) {

		let d = duration;

		const hours = d / this.HOUR;
		d %= this.HOUR;

		const minutes = d / this.MINUTE;
		d %= this.MINUTE;

		const seconds = d / this.SECOND;
		d %= this.SECOND;

		return `${this.zeroPadding(hours, 2)}:${this.zeroPadding(minutes, 2)}:${this.zeroPadding(seconds, 2)}`;
	}

	public static formatDurationHHMMSS(duration){

		let seconds = Math.floor(duration / 1000);
		let minutes = Math.floor(seconds / 60);
		let hours = Math.floor(minutes / 60);

		seconds = seconds % 60;
		minutes = minutes % 60;

		hours = hours % 24;

		return `${DateTimeUtil.padTo2Digits(hours)}:${DateTimeUtil.padTo2Digits(minutes)}:${DateTimeUtil.padTo2Digits(
			seconds,
		)}`;
	}

	private static padTo2Digits(num) {
		return num.toString().padStart(2, '0');
	}

	private static zeroPadding(str: string | number, pad: number): string {
		let s = str + "";

		while (s.length < pad) {
			s = "0" + s;
		}

		return s;
	}

	public static isAfter(date1: Date | string, date2: Date | string): boolean {
		//if any for paramater is string first convert it into date
		try {
			if ((date1 === undefined || date1 === null) || (date2 === undefined || date2 === null)) throw new Error("Null values");
			if (typeof date1 === 'string') date1 = new Date(date1);
			if (typeof date2 === 'string') date2 = new Date(date2);

			var date_1 = moment(date1, 'YYYY-MM-DD');
			var date_2 = moment(date2, 'YYYY-MM-DD');
			return date_2.isAfter(date_1);
		} catch {
			return false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/core/util/DateTimeUtil.ts